exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoginModal-module__wrapper___U6M-u{display:grid}.LoginModal-module__wrapper___U6M-u .LoginModal-module__error___1QS8T{color:#f66;text-transform:uppercase;font-weight:500;letter-spacing:.5px;margin-bottom:.75em}", ""]);

// exports
exports.locals = {
	"wrapper": "LoginModal-module__wrapper___U6M-u",
	"error": "LoginModal-module__error___1QS8T"
};